import { Component } from '@angular/core';
import { LearnexService } from '@app/service/learnex.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import {ThemePalette} from '@angular/material/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
@Component({
  selector: 'app-learnex',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    TranslateModule,
    MatIconModule,
    RouterLink,
    MatListModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatCardModule, 
  ],
  templateUrl: './learnex.component.html',
  styleUrl: './learnex.component.css'
})
export class LearnexComponent {
  color : ThemePalette = 'accent';
  apexId!:string;
  browserLangToUse = '';
  constructor(
    private learnexServiceService: LearnexService,        
    public translate: TranslateService,
    private location: Location,
  ) { 
      translate.setDefaultLang('en');
      let browserLangToUse = '';
      let browserLang = translate.getBrowserCultureLang();
      browserLangToUse = browserLang === undefined ? 'en' : browserLang;
      translate.use(browserLangToUse);
      this.browserLangToUse = browserLangToUse;
  }

  ngOnInit(): void {
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      console.log(`learn ex not override apex id`);
      this.pageInitialization();
    } 
    else{
      console.log(`learn ex override apex id`);
      this.pageInitializationOverride(overrideObjectString);
    }
  }
  private pageInitializationOverride(overrideObjectString:string): void{
    let overrideObject = JSON.parse(overrideObjectString);
    let apexid = overrideObject.apexid;
    this.apexId = apexid;
    let language = this.getLanguage();
    console.log({
      "window.navigator.language": window.navigator.language,
      language: language,
    });
    this.isLoading = true;
    this.getLearnexByApexIdLanguage(apexid, language);
  }
  isLoading = false;
  private pageInitialization(): void {
    this.isLoading = true;
    let apexId = localStorage.getItem("apexid"); 
    this.apexId = apexId!;
    let language = this.getLanguage();
    console.log({
      "window.navigator.language": window.navigator.language,
      language: language,
    });
    if(apexId !== null){      
      this.getLearnexByApexIdLanguage(apexId, language);    
    }
  }
  getLanguage() :string{
    
    let language = '1';
    if(window.navigator.language.toLowerCase().includes('tw')){
      language = '34';
    }
    if(window.navigator.language.toLowerCase().includes('cn')){
      language = '7';
    }
    if(window.navigator.language.toLowerCase().includes('sg')){
      language = '1';
    }
    if(window.navigator.language.toLowerCase().includes('ko')){
      language = '30';
    }
    if(window.navigator.language.toLowerCase().includes('ms')){
      language = '38';
    }
    return language;
  }
  learnexObjectArray!:any;
  learnexObjectArrayOverDue!:any[];
  learnexObjectArrayDueSoon!:any[];
  learnexObjectArrayNoDueDate!:any[];
  
  getLearnexByApexIdLanguage(apexid:string, language:string):void{
    this.learnexObjectArrayOverDue = [];
    this.learnexObjectArrayDueSoon = [];
    this.learnexObjectArrayNoDueDate = [];

    this.learnexServiceService.getLearnex(apexid, language).subscribe(responseLearnexObjectArray => {
      this.learnexObjectArray = responseLearnexObjectArray;
      if(this.learnexObjectArray.totalCount > 0){
        for(const learnex of this.learnexObjectArray.data){
          if(learnex.type === 'overdue'){
            this.learnexObjectArrayOverDue.push(learnex);
          }
          else if(learnex.type === 'duesoon'){
            this.learnexObjectArrayDueSoon.push(learnex);
          }
          else if(learnex.type === 'noduedate'){
            this.learnexObjectArrayNoDueDate.push(learnex);
          }
        }
      }
      this.isLoading = false;
    });
  }

  backClicked() {
    this.location.back();
  }

}
